<template>
    <div class="app-container" :class="$route.meta.class">
        <div
            class="page-banner"
            :style="`background-image: url(${$publicPath}/static/banner/${$route.meta.class}.jpg);`"
        >
            <div class="page-banner__inside width-master">
                <div class="page-banner__title">{{ $route.meta.en_title }}</div>
                <div class="page-banner__subtitle">{{ $route.meta.title }}</div>
                <div class="page-banner__desc">
                    {{ $route.meta.desc }}
                </div>
            </div>
        </div>

        <div class="page-block width-master">
            <div class="page-breadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }"
                        >首页</el-breadcrumb-item
                    >
                    <el-breadcrumb-item>{{
                        $route.meta.title
                    }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <div class="news-block__carousel product-detail__carousel">
                <CarouselTwo></CarouselTwo>
            </div>
        </div>
        <div class="p-cpys"
        :style="`background-image: url(${$publicPath}/static/products/p-cpys.jpg);`"
        ></div>
        <div class="p-cpys-2"
        :style="`background-image: url(${$publicPath}/static/products/p-cpys-2.jpg);`"
        ></div>
    </div>
</template>
<script>
import CarouselTwo from "@/components/CarouselTwo.vue";
export default {
    name: "ProductsDetail",
    components: {
        CarouselTwo,
    },
    data() {
        return {
            name: 'ProductsDetail'
        }
    }
}
</script>
<style lang="scss">
.product-detail__carousel {
    padding-top: 50px;
    padding-bottom: 100px;
}
    .p-cpys {
        height: 1284px;
    }
     .p-cpys-2 {
        height: 3300px;
    }
    .p-cpys, .p-cpys-2 {
        background-size: cover;
        background-repeat: no-repeat;
        background-position: top center;
    }
</style>